module.exports = __webpack_public_path__ + "img/course_cate_01.a8ef192e.png";